import React from 'react';
import { CardMedia, Stack, Typography } from '@mui/material';
import FocusInspectionButtonWeb from './FocusInspectionButtonWeb';

const HardEarnedSection = () => (
  <Stack sx={{ pt: 15, pb: 20, pr: '75px', pl: '90px', backgroundColor: 'white' }}>
    <Stack flexDirection="row" justifyContent="space-between" pb={8} gap={10}>
      <Stack maxWidth={360}>
        <Typography color="#121212" fontWeight={700} fontSize={48} lineHeight={1.2}>
          Don't Risk Your Hard-Earned Money!!!
        </Typography>
      </Stack>
      <Stack maxWidth={460} mr={2}>
        <Typography color="#121212" fontWeight={600} fontSize={23} lineHeight={1.5}>
          Buying a used car from unknown sellers can be risky—
        </Typography>
        <Typography color="#121212" fontWeight={400} fontSize={23} ineHeight={1.5}>
          mechanic checks may miss hidden issues, leaving you unprotected and unsure.
        </Typography>
      </Stack>
    </Stack>
    <Stack gap={10} flexDirection="row">
      <Stack gap={8} width="38%" justifyContent="center">
        <CardMedia
          component="img"
          className=""
          src="assets/images/Inspection/dummyCar.webp"
          alt="Focus Inspection"
          // height={isMobile ? 25 : 40}
          sx={{ objectFit: 'contain', borderRadius: '10px', height: 110, width: 'fit-content' }}
        />
        <Stack mt={2} gap={1}>
          <Typography color="#000000" fontSize="19px" fontWeight={400}>
            ❓ Uncertainty about car's real condition
          </Typography>
          <Typography color="#000000" fontSize="19px" fontWeight={400}>
            🔧 Traditional checks miss hidden issues
          </Typography>
          <Typography color="#000000" fontSize="19px" fontWeight={400}>
            😟 Anxious and unprotected purchases
          </Typography>
        </Stack>
        <FocusInspectionButtonWeb
          title="Book  Your Inspection Now"
          subtitle="Inspection team will contact you soon."
          subTitleColor="#121212"
          onClick={() => console.log('Button clicked')}
        />{' '}
      </Stack>
      <Stack width="62%" justifyContent="end">
        <CardMedia
          component="img"
          className=""
          src="assets/images/Inspection/hardEarned.webp"
          alt="Focus Inspection"
          // height={isMobile ? 25 : 40}
          sx={{ objectFit: 'contain', borderRadius: '10px' }}
        />
      </Stack>
    </Stack>
  </Stack>
);

export default HardEarnedSection;
